import { render, staticRenderFns } from "./translateDialog.vue?vue&type=template&id=7d74e964&"
import script from "./translateDialog.vue?vue&type=script&lang=js&"
export * from "./translateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports